import { action, observable, computed } from "mobx";
import { post } from "../../services/ajax-calls.service";


class MedicalInsightsStore {
  @observable url = "/api/v1/medicalActions/insights";
  @observable total_count = {};
  @observable totalInPatientParticipants = {};
  @observable totalOutPatientParticipants = {};
  @observable chronicIndicatorBreakdown = {};
  @observable highestUtilizedFacilities = [];
  @observable listofMedicareFacilities = [];
  @observable listofMedicareProcedures = [];
  @observable j_code_list = [];
  @observable j_code_list_without_corresponding = [];
  @observable percent_of_medicare = "";
  @observable percent_of_medicare_facility = "";
  @observable j_code_summary = {};
  @observable get_j_unspecified_code_summary = {};
  @observable j_index_screen = {};
  @observable j_index_screen_non = {};
  @observable drugs_for_j_code = [];
  @observable drugs_for_unrecognized_claims = [];
  @observable drugs_for_unrecognized_claims_detail = [];

  @observable acute = [];
  @observable chronic = [];
  @observable acute_with_chronic = [];
  @observable others = [];


  @observable filterValue = "";


  @computed get tiles() {
    return parseInt(this.total_count / 100) > 0 ? parseInt(this.total_count / 100) + 1 : 0;
  }


  @action sortby(filter) {
    this.filterValue = filter;
    if (this.highestUtilizedFacilities.length > 0) {
      if (filter == "patient_responsibility") {
        this.highestUtilizedFacilities = this.highestUtilizedFacilities.sort(function (a, b) {
          if (parseInt(a.Patient_Responsibility) > parseInt(b.Patient_Responsibility)) return -1;
          if (parseInt(a.Patient_Responsibility) < parseInt(b.Patient_Responsibility)) return 1;
          return 0
        })
      }
      if (filter == "total_plan_pay") {
        this.highestUtilizedFacilities = this.highestUtilizedFacilities.sort(function (a, b) {
          if (parseInt(a.Total_Plan_Pay) > parseInt(b.Total_Plan_Pay)) return -1;
          if (parseInt(a.Total_Plan_Pay) < parseInt(b.Total_Plan_Pay)) return 1;
          return 0
        })
      }
      if (filter == "total_allowed") {
        this.highestUtilizedFacilities = this.highestUtilizedFacilities.sort(function (a, b) {
          if (parseInt(a.Total_Allowed) > parseInt(b.Total_Allowed)) return -1;
          if (parseInt(a.Total_Allowed) < parseInt(b.Total_Allowed)) return 1;
          return 0
        })
      }
      if (filter == "total_charges") {
        this.highestUtilizedFacilities = this.highestUtilizedFacilities.sort(function (a, b) {
          if (parseInt(a.Total_Charges) > parseInt(b.Total_Charges)) return -1;
          if (parseInt(a.Total_Charges) < parseInt(b.Total_Charges)) return 1;
          return 0
        })
      }
      if (filter == "claims_count") {
        this.providers = this.providers.sort(function (a, b) {
          if (a.claims_count > b.claims_count) return -1;
          if (a.claims_count < b.claims_count) return 1;
          return 0
        })
      }
      if (filter == "participant_count") {
        this.providers = this.providers.sort(function (a, b) {
          if (a.participant_count > b.participant_count) return -1;
          if (a.participant_count < b.participant_count) return 1;
          return 0
        })
      }
    }
  }
  @action getTotalInPatientParticipants = async (data) => {
    this.totalInPatientParticipants = {}
    try {
      let response = await post(
        `${this.url}/getTotalInPatientParticipants`,
        data
      );
      this.totalInPatientParticipants = response.data.in_patient_total_participants;
    } catch (err) {
      console.log(err);
    }
  }

  @action getTotalOutPatientParticipants = async (data) => {
    this.totalOutPatientParticipants = {}
    try {
      let response = await post(
        `${this.url}/getTotalOutPatientParticipants`,
        data
      );
      this.totalOutPatientParticipants = response.data.out_patient_total_participants;
    } catch (err) {
      console.log(err);
    }
  }
  @action getChronicIndicatorBreakdown = async (data) => {
    this.chronicIndicatorBreakdown = {};
    try {
      let response = await post(
        `${this.url}/getChronicIndicatorBreakdown`,
        data
      );
      let getSum = response.data.reduce((a, b) => {
        if (b?.chronic_indicator != "N") {
          return a + b?.total_participants
        }
        else {
          return a
        }
      }, 0)
      // this.chronicIndicatorBreakdown=response.data;
      let tempArr = {}
      for (const d of response.data) {
        tempArr[d.chronic_indicator] = { total_allowed: d.total_allowed, total_participants: d.total_participants, percentage: this.getParticipantsPercentage(d.total_participants, getSum) }
      }
      this.chronicIndicatorBreakdown = tempArr;
    } catch (err) {
      console.log(err);
    }
  }
  getParticipantsPercentage = (value, sum) => {
    return Math.round((value * 100) / sum);
  }
  @action getHighestUtilizedFacilities = async (data) => {
    this.highestUtilizedFacilities = [];
    try {
      let response = await post(
        `${this.url}/getHighestUtilizedFacilities`,
        data
      );
      this.highestUtilizedFacilities = response.data;

    } catch (err) {
      console.log(err);
    }
  }

  @action getAcute = async (data) => {
    this.acute = [];
    this.acute = await this.getParticipantsByChronicIndicator(data)
  }
  @action getChronic = async (data) => {
    this.chronic = [];
    this.chronic = await this.getParticipantsByChronicIndicator(data)
  }
  @action getAcuteWithChronic = async (data) => {
    this.acute_with_chronic = [];
    this.acute_with_chronic = await this.getParticipantsByChronicIndicator(data)
  }
  @action getOthers = async (data) => {
    this.others = [];
    this.others = await this.getParticipantsByChronicIndicator(data)
  }

  getParticipantsByChronicIndicator = async (data) => {
    try {
      let response = await post(
        `${this.url}/getParticipantsByChronicIndicator`,
        data
      );
      return response.data;

    } catch (err) {
      console.log(err);
    }
  }
  getMedicarePercentageOverall = async (data) => {
    this.percent_of_medicare = "";
    try {
      let response = await post(
        `${this.url}/getMedicarePercentageOverall`,
        data
      );
      this.percent_of_medicare = response.data[0].percent_of_medicare;

    } catch (err) {
      console.log(err);
    }
  }
  getMedicarePercentageOverFacilities = async (data) => {
    this.percent_of_medicare_facility = "";
    try {
      let response = await post(
        `${this.url}/getMedicarePercentageOverFacilities`,
        data
      );
      this.percent_of_medicare_facility = response.data[0].percent_of_medicare;

    } catch (err) {
      console.log(err);
    }
  }
  getListofMedicareFacilities = async (data) => {
    this.listofMedicareFacilities = [];
    try {
      let response = await post(
        `${this.url}/getListofMedicareFacilities`,
        data
      );
      this.listofMedicareFacilities = response.data;

    } catch (err) {
      console.log(err);
    }
  }
  getListofMedicareProcedures = async (data) => {
    this.listofMedicareProcedures = [];
    try {
      let response = await post(
        `${this.url}/getListofMedicareProcedures`,
        data
      );
      this.listofMedicareProcedures = response.data;

    } catch (err) {
      console.log(err);
    }
  }
  get_j_code_summary = async (data) => {
    this.j_code_summary = {};
    try {
      let response = await post(
        `${this.url}/get_j_code_summary`,
        data
      );
      this.j_code_summary = response.data[0];

    } catch (err) {
      console.log(err);
    }
  }
  get_j_index_screen = async (data) => {
    this.j_index_screen = {};
    try {
      let response = await post(
        `${this.url}/get_j_index_screen`,
        data
      );
      this.j_index_screen = response.data[0];

    } catch (err) {
      console.log(err);
    }
  }
  get_j_index_screen_non_ndc = async (data) => {
    this.j_index_screen_non = {};
    try {
      let response = await post(
        `${this.url}/get_j_index_screen_non_ndc`,
        data
      );
      this.j_index_screen_non = response.data[0];

    } catch (err) {
      console.log(err);
    }
  }
  get_unspecified_JCode = async (data) => {
    this.get_j_unspecified_code_summary = {};
    try {
      let response = await post(
        `${this.url}/get_j_unspecified_code_summary`,
        data
      );
      this.get_j_unspecified_code_summary = response.data[0];

    } catch (err) {
      console.log(err);
    }
  }
  get_j_codes_list = async (data) => {
    this.j_code_list = [];
    try {
      let response = await post(
        `${this.url}/get_j_codes_list`,
        data
      );
      this.j_code_list = response.data;

    } catch (err) {
      console.log(err);
    }
  }
  get_j_codes_list_without_corresponding = async (data) => {
    this.j_code_list_without_corresponding = [];
    try {
      let response = await post(
        `${this.url}/get_j_codes_list_without_corresponding`,
        data
      );
      this.j_code_list_without_corresponding = response.data;

    } catch (err) {
      console.log(err);
    }
  }
  get_drugs_for_j_code = async (data) => {
    this.drugs_for_j_code = [];
    try {
      let response = await post(
        `${this.url}/get_drugs_for_j_code`,
        data
      );
      this.drugs_for_j_code = response.data;

    } catch (err) {
      console.log(err);
    }
  }
  get_unrecognized_claims = async (data) => {
    this.drugs_for_unrecognized_claims = [];
    try {
      let response = await post(
        `${this.url}/get_unrecognized_claims`,
        data
      );
      this.drugs_for_unrecognized_claims = response.data[0];

    } catch (err) {
      console.log(err);
    }
  }
  get_unrecognized_claims_detail = async (data) => {
    this.drugs_for_unrecognized_claims_detail = [];
    try {
      let response = await post(
        `${this.url}/get_unrecognized_claims_detail`,
        data
      );
      this.drugs_for_unrecognized_claims_detail = response.data;

    } catch (err) {
      console.log(err);
    }
  }
  get_unrecognized_claims_detail_count = async (data) => {
    this.total_count = [];
    try {
      let response = await post(
        `${this.url}/get_unrecognized_claims_detail_count`,
        data
      );
      this.total_count = response.data[0]?.total;

    } catch (err) {
      console.log(err);
    }
  }
}

export default MedicalInsightsStore;